import React from 'react';
import { Container } from '@/components/elements/Container';
import { OverlayingPopup } from '@/components/elements/OverlayingPopup';
import { useTranslationWithLocale } from '@/hooks';
import styles from './VideoLoadingOverlay.module.scss';

interface Props {
	percentage: number;
}

export const VideoLoadingOverlay: React.FC<Props> = ({ percentage }) => {
	const { t } = useTranslationWithLocale('common');

	return (
		<OverlayingPopup
			classes={{
				popup: styles['popup'],
				overlay: styles['popup__overlay'],
			}}
			escapeClose
		>
			<Container className={styles['popup__container']}>
				<div className={styles['card']}>
					<h2 className={styles['card__title']}>
						{t('videoUploadLoading_title')}
					</h2>
					<p className={styles['card__subtitle']}>
						{t('videoUploadLoading_subtitle')}
					</p>
				</div>

				<div className={styles['progress']}>
					<div
						className={styles['progress__fill']}
						style={{ width: `${percentage}%` }}
					/>
				</div>
			</Container>
		</OverlayingPopup>
	);
};
